export {
    userLogin,
    userLogout,
    setTopbarTheme,
    openSignInModal,
    openForgotPasswordModal,
    setBasicUserDetails,
    setInitialProgramData,
    setInitialModuleData,
    setContinueLearningData,
    setOngoingProgramData,
    setEnrolledProgramsData,
    setActiveProgramId,
    setActiveModuleId,
    setUnreadNotifCount,
    setupProgramDetailsTopbar,
    showQuizNavbar,
    onProfilePicUpdated,
    hideTopbarStrip,

    onFailureDialogShow,
    onFailureDialogHide,
    onSuccessDialogShow,
    onSuccessDialogHide,

    redirectToUnauthorized,
    redirectToNotFound,
    redirectToServerError,
    resetAllErrorPages,
    updateLeanerLiveSessionStatus,
    showSessionExpiredDialog,
    redirectToHome,

} from './mainLayoutActions';